import { removeMask } from '../utils/remove-mask';
import { MetodoPagamentoVendaEnum } from '../types/enums/metodo-pagamento.enum';
import { getAllUrlParams, getUrlParams } from '../utils/get-url-params';
import { emitUtmifyEvent } from '../utils/emitUtmifyEvent';

export const boletoStrategy = async ({
  data,
  checkout,
  id,
  api,
  gerarTokenRecaptcha,
  navigate,
}: any) => {
  const recaptcha = await gerarTokenRecaptcha(`/venda`);
  const afiliadoId = getUrlParams('affiliate') ?? undefined;

  const purchase = await api.Venda.createPix({
    metodoPagamento: MetodoPagamentoVendaEnum.BOLETO,
    produtoId: id ?? '',
    emailComprador: data.email,
    nomeComprador: data.fullName,
    sobrenomeComprador: data.fullName,
    cpfComprador: removeMask(data.cpf),
    telefoneComprador: removeMask(data.phoneNumber),
    checkoutId: checkout?.id,
    recaptchaToken: recaptcha,
    postalCode: data?.postalCode,
    state: data?.state,
    city: data?.city,
    district: data?.neighborhood,
    address: data?.address,
    number: data?.number,
    complement: data?.complement,
    afiliadoId,
    utmSource: getUrlParams('utm_source'),
    utmCampaign: getUrlParams('utm_campaign'),
    utmMedium: getUrlParams('utm_medium'),
    utmContent: getUrlParams('utm_content'),
    utmTerm: getUrlParams('utm_term'),
    sck: getUrlParams('sck') ?? undefined,
    src: getUrlParams('src') ?? undefined,
    urlParams: getAllUrlParams(),
  });

  emitUtmifyEvent({
    event: 'waiting_payment',
    vendaId: purchase?.data?.id,
  });
  navigate('/venda/boleto', { state: { purchase, checkout } });
};
